module.exports = __webpack_public_path__ + "img/camara_celular.7534bd29.png";